import Plugin from 'src/plugin-system/plugin.class';
import sal from 'sal.js'

export default class AnimationsPlugin extends Plugin {

    init() {
        window.scrollAnimations = sal();
    }

}
